import Vue from "vue";
import App from "./App.vue";
import router from "./router/router";
import store from "./store/store";
import api from "./api";
import VueLazyload from "vue-lazyload";
import william from "./mo";

import "@/assets/index.scss";
import { unbreakable } from "./util/func";

Vue.use(VueLazyload, {
  lazyComponent: true,
  observer: true
});

Vue.filter("ellipsis", (str, len = 60) => {
  return str.length < len ? str : str.slice(0, len) + " [...]";
});

Vue.filter("plural", (str, array) => {
  return array.length > 1 ? str + "s" : str;
});

Vue.filter("mo", str => (str ? william.format(str, "brut") : ""));
Vue.filter("moHtml", str =>
  william.format(william.format(str, "brut"), "html")
);
Vue.filter("u", str => (str ? unbreakable(str) : ""));
Vue.filter("glue", str => str.replace(/\s/g, "\u00A0"));

Vue.config.productionTip = false;

const app = new Vue({
  router,
  store,
  render: h => h(App)
});

app.$api = api;
app.$d = () => new Promise(r => setTimeout(r, 500));
app.$mount("#app");
